"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const ControlMessage_1 = __importDefault(require("../ControlMessage"));
const MessageRef_1 = __importDefault(require("../../message_layer/MessageRef"));
const ResendFromRequest_1 = __importDefault(require("./ResendFromRequest"));
const Serializer_1 = require("../../../Serializer");
const VERSION = 2;
class ResendFromRequestSerializerV2 extends Serializer_1.Serializer {
    toArray(resendFromRequest) {
        return [
            VERSION,
            ControlMessage_1.default.TYPES.ResendFromRequest,
            resendFromRequest.requestId,
            resendFromRequest.streamId,
            resendFromRequest.streamPartition,
            resendFromRequest.fromMsgRef.toArray(),
            resendFromRequest.publisherId,
            resendFromRequest.sessionToken,
        ];
    }
    fromArray(arr) {
        const [version, type, // eslint-disable-line @typescript-eslint/no-unused-vars
        requestId, streamId, streamPartition, fromMsgRefArray, publisherId, sessionToken,] = arr;
        const [fromTimestamp, fromSequenceNumber] = fromMsgRefArray;
        return new ResendFromRequest_1.default({
            version, requestId, streamId, streamPartition, fromMsgRef: new MessageRef_1.default(fromTimestamp, fromSequenceNumber), publisherId, sessionToken
        });
    }
}
exports.default = ResendFromRequestSerializerV2;
ControlMessage_1.default.registerSerializer(VERSION, ControlMessage_1.default.TYPES.ResendFromRequest, new ResendFromRequestSerializerV2());
//# sourceMappingURL=ResendFromRequestSerializerV2.js.map